export interface CheckoutQuoteAmounts {
  freightCents: number;
  liftGateCents: number;
  productSubtotals?: ReadonlyArray<{ subtotalCents: number }>;
}

export interface CheckoutQuoteSummary {
  goodsCents: number;
  deliveryCents: number | null;
  liftGateCents: number;
  totalBeforeTaxCents: number | null;
}

export function checkoutDeliveryCents(quote: CheckoutQuoteAmounts): number {
  return quote.freightCents - quote.liftGateCents;
}

export function checkoutQuoteSummary(
  cartGoodsCents: number,
  quote: CheckoutQuoteAmounts | null,
): CheckoutQuoteSummary {
  const goodsCents =
    quote?.productSubtotals?.reduce((sum, entry) => sum + entry.subtotalCents, 0) ??
    cartGoodsCents;
  if (!quote) {
    return { goodsCents, deliveryCents: null, liftGateCents: 0, totalBeforeTaxCents: null };
  }
  return {
    goodsCents,
    deliveryCents: checkoutDeliveryCents(quote),
    liftGateCents: quote.liftGateCents,
    totalBeforeTaxCents: goodsCents + quote.freightCents,
  };
}
